// extracted by mini-css-extract-plugin
export default {"list":"PatientsList_list__lGNAx"};